import { ROOT_ROLE } from "../../constants/user";

/**
 * Resolve the tenant visible to this render, never from mutable browser storage:
 * the ROOT user's selected customer, otherwise the authenticated user's own. Every
 * customer logs activity — there is no tenant allowlist on either side of the
 * gateway; atomic-core translates the id to a roster company (and keeps one it
 * does not know as unresolved rather than dropping it).
 */
export const effectiveActivityCustomerId = ({
  actualRole,
  selectedCustomerId,
  userCustomerId,
}: {
  actualRole: string | null;
  selectedCustomerId: string | null;
  userCustomerId: string | null | undefined;
}): string | null => {
  const effectiveCustomerId =
    actualRole === ROOT_ROLE ? selectedCustomerId : userCustomerId;
  return typeof effectiveCustomerId === "string" && effectiveCustomerId.trim()
    ? effectiveCustomerId
    : null;
};
